module.exports = __webpack_public_path__ + "img/cast_about_image2@2x.883ae33a.png";